import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {environment} from '../environments/environment';
import {TranslateService} from '@brunata-angular/util';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map, switchMap} from 'rxjs';
import {take} from 'rxjs/operators';
import {Title} from '@angular/platform-browser';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
    private readonly environmentGuideMap: Record<
        string,
        {
            favicon: string;
            title: string;
        }
    > = {
        local: {
            favicon: 'faviconlocal.ico',
            title: `${this.titleService.getTitle()} local`,
        },
        development: {
            favicon: 'favicondev.ico',
            title: `${this.titleService.getTitle()} development`,
        },
        test: {
            favicon: 'favicontest.ico',
            title: `${this.titleService.getTitle()} test`,
        },
    };
    constructor(
        private titleService: Title,
        public translateService: TranslateService,
        private activateRoute: ActivatedRoute,
        private router: Router,
    ) {
        // this waits for the navigation to end successfully.
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                switchMap(() => this.activateRoute.queryParamMap),
                take(1),
                map(queryParamMap => queryParamMap.get('lang')),
            )
            .subscribe(language => {
                this.translateService.setLanguage(language);
            });
    }

    ngOnInit(): void {
        if (environment.production === false) {
            const favicon = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
            favicon?.setAttribute('href', this.environmentGuideMap[environment.env].favicon);
            this.titleService.setTitle(this.environmentGuideMap[environment.env].title);
        }
    }
}
